import IdValueObj from "./IdValueObj";
export default class GenericIdValueList {
  constructor(name, initialValue=[], namespace) {
    this.namespace=namespace;
    this.name=name;
    this.list=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addItem();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getList() {
    return this.list;
  }

  addItem(value) {
    const obj=new IdValueObj();
    obj.setValue(value);
    this.list.push(obj);
  }

  removeItem(index) {
    if (index>=this.list.length||index<0) {
      return;
    }
    this.list.splice(index, 1);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        const obj = new IdValueObj();
        obj.setValue(value[obj.id]);
        this.list.push(obj);
      }
    } else {
      if (obj) { // offers have different objects in landing pages, we have to check if the element is undefined
        const obj = new IdValueObj();
        obj.setValue(inputJSON[obj.id]);
        this.list.push(obj);
      } else { // if obj is undefined don't not initialize it with inputJSON[obj.id] because it will create a non-empty object with id=offer_id which is then visible in the landing page
        const obj = new IdValueObj();
        this.list.push(obj);
      }
    }
  }

  print() {
    for (let i=0; i<this.list.length; i++) {
      this.list[i].print();
    }
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.list.length; index++) {
      const item=this.list[index];
      if (!item.isEmpty()) {
        expandedList.push(item.getExpandedFormatValue());
      }
    }
    return expandedList;
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.list.length; index++) {
      const item=this.list[index];
      condition=condition&&item.isEmpty();
    }
    return condition;
  }
}
